import styled from 'styled-components';
import { rem } from 'polished';
import { TimePicker } from '@material-ui/pickers';
import mediaqueries from '../../../config/themes/variables/mediaqueries';

export const StyledWrapperTimes = styled.div`
  display: flex;
`;

export const StyledTimePicker = styled(TimePicker)`
  width: 100%;

  /* Input */
  .MuiInputBase-root {
    &:before {
      border: none;
    }
  }
  .MuiInput-underline:hover:not(.Mui-disabled):before,
  .MuiInput-underline:after {
    border: none;
  }
  .MuiInputBase-input {
    line-height: 1.2;
    /* Estilos comunes Input y text Area */
    padding: ${rem('11px')} ${rem('18px')} ${rem('11px')} ${rem('8px')};
    width: 100%;
    font-size: ${rem('14px')};
    border: ${rem('1px')} solid #d0d0d0;
  }
  .MuiInput-underline.Mui-error:after {
    border: none;
  }
  .MuiFormHelperText-root.Mui-error {
    font-size: ${rem('14px')};
    color: #e71d02;
  }
  /* Calendar */
  .MuiPickerDTToolbar-toolbar {
    background-color: #f95752;
  }
  .MuiInput-underline:after {
    border: none;
  }
  .MuiInput-underline:after {
    border: none;
  }
`;
